import { useEffect, useState } from "react";

import { appStoreUrl, playStoreUrl } from "../config/site";
import {
  inboundSource,
  rememberInboundSource,
  storeCampaignTag,
} from "./inboundSource";

const buildLinks = (pageCampaign, inbound) => {
  const campaign = storeCampaignTag(pageCampaign, inbound);
  return {
    campaign,
    appStoreUrl: appStoreUrl(campaign),
    googleStoreUrl: playStoreUrl(campaign, inbound),
  };
};

// Store links for a page. The server render carries the page's own tag so the
// links work without JavaScript; once the page is on screen, the visit's
// inbound source, if any, is added to them.
export const useStoreLinks = (pageCampaign) => {
  const [links, setLinks] = useState(() => buildLinks(pageCampaign, null));

  useEffect(() => {
    const inbound =
      rememberInboundSource(window.location.search) || inboundSource();
    setLinks(buildLinks(pageCampaign, inbound));
  }, [pageCampaign]);

  return links;
};
